import Model from "./model";

export default new Model({
  resource : "cuartel",
  grouped : true,
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"nombre", default:"-", required: true, type:"text", width: 300},
    {label:"Código", nameAttr:"codigo", default:"-", required: true, type:"text", width: 100},
    {label:"Superficie", nameAttr:"superficie", default:0, required: true, type:"text", width: 60},
    {label:"Campo", nameAttr:"campo_id", default:null, required: true, type:"select", model:"campoModel", newItem:true, searchPath:"nombre", width: 150},
    {label:"Especie", nameAttr:"especie_id", default:null, required: true, type:"select", model:"especieModel", newItem:true, searchPath:"nombre", width: 200},
    {label:"Variedad", nameAttr:"variedad_id", default:null, required: true, type:"select", model:"variedadModel", newItem:true, searchPath:"nombre", width: 200},
  ]
});
